import { computed, type ComputedRef } from 'vue';
import { useAccountConfig } from '../config/accountConfig';
import {
  connectPresentationConfigKey,
  resolveConnectPresentation,
  type ConnectPresentation,
  type ConnectScreenDefinition,
} from './screen';

/** Which presentation a screen shows. */
export interface ConnectPresentationState {
  readonly definition: ConnectScreenDefinition<unknown>;
  /** The presentation that shows: the stored one, else the screen's default. */
  readonly current: ComputedRef<ConnectPresentation>;
}

/**
 * The presentation state of a screen, read from `<app>.presentation` (one
 * shared store per key: every screen of an app reads the same document). The
 * choice is made in the settings list only — no screen offers a switch of its
 * own — so a change there shows at once.
 */
export function useConnectPresentation(
  definition: ConnectScreenDefinition<unknown>
): ConnectPresentationState {
  const config = useAccountConfig<Record<string, unknown>>(
    connectPresentationConfigKey(definition.app)
  );
  const current = computed(() =>
    resolveConnectPresentation(definition, config.effective.value?.[definition.id])
  );
  return { definition, current };
}
